import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LabelTransformer, DiffBase } from '../diff-base';

const isOutsideHrmDiff: FC = (props) => {
  const { t } = useTranslation();

  const labelTransformer: LabelTransformer<'isOutsideHrm'> = (el) => t(`buttons.${el.data ? 'yes' : 'no'}`);

  return <DiffBase fieldName="isOutsideHrm" labelTransformer={labelTransformer} {...props} />;
};

export default isOutsideHrmDiff;
